import React, {useEffect, useRef} from "react";

export default function DeleteModal(props) {
  const modalRef = useRef();

  useEffect(() => {
    const handleMouseUp = (event) => {
      if (!modalRef.current.contains(event.target)) {
        props.onCancel();
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        props.onCancel();
      }
    };

    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props]);

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-8 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-stone-950 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <div ref={modalRef}
             className="inline-block align-bottom bg-white dark:bg-stone-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="flex flex-col h-full">
            <div className="bg-white dark:bg-stone-800 px-4 py-6 sm:p-6 flex-grow flex items-center justify-center">
              <div className="sm:flex sm:items-center">
                <div className="text-center sm:text-left">
                  <h3 className="pt-6 text-lg leading-6 font-semibold text-gray-900 dark:text-gray-200"
                      id="modal-headline">
                    {props.title}
                  </h3>
                  <div className="mt-1 dark:text-gray-300">{props.children}</div>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-stone-800 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-center">
              <button
                onClick={props.onCancel}
                type="button"
                className="mt-3 w-28 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 focus:outline-none sm:ml-2 sm:text-sm sm:mt-0"
              >
                No
              </button>
              <button
                onClick={props.onDelete}
                type="button"
                className="mt-3 w-28 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white bg-red-500 hover:bg-red-700 focus:outline-none sm:ml-2 sm:text-sm sm:mt-0"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
